import { combineReducers } from 'redux';
import { alert } from './alert.reducer';
import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { wallet } from './wallet.reducer';
import { loading } from './loading.reducer';
import { fetching } from './fetching.reducer';
import { ticker } from './ticker.reducer';
import { loadingBarReducer } from 'react-redux-loading-bar'

const rootReducer = combineReducers({
    alert , 
    authentication , 
    registration , 
    loading ,
    loadingBar: loadingBarReducer , 
    wallet , 
    fetching , 
    ticker
}); 

export default rootReducer;

//Dev note : all reducers will get called once an action is dispatched 


// WEBPACK FOOTER //
// ./src/_reducers/index.js